import React, { useState, useEffect } from 'react';
import './styles/App.css';
import { PageLayout } from './components/PageLayout';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import Button from 'react-bootstrap/Button';
import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { ProfileData } from './components/ProfileData';


/*
 * Copyright (c) MDR Computer Services Pty Ltd. 

 */



const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);



    useEffect(() =>{ {
   

        
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],

                

            })
            .then((response) => {
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
   
        
            });


        }
      



        const myHeaders = new Headers();
        myHeaders.append("APIKEY", process.env.REACT_APP_API_KEY);
        myHeaders.append("Access-Control-Allow-Origin", "*");
        
        
            const requestOptions = {
                method: 'PUT',      
                headers: myHeaders,
                  redirect:'follow'
            };
        
            const PutUser= async () => {
              
                 await getUser()
                 }
             
          
             
             const getUser = async () =>{
                
                 const url=`https://cfmlogin.summitsafety.com.au/api/user/${accounts[0].username + "/"}`
                 const res = await fetch(url, requestOptions)
                 const data = await res.json()
                 console.log(data)
                 respRedirect(data)
                 }
             
             PutUser()

             const respRedirect = (user) => {
                setTimeout(() =>
                {
                    if(user.trim() === "Login Successful"){
                        window.location.replace('https://cfmorders.summitsafety.com.au/'); 
                  
                    }else{



                           alert("Login Failed - please try again later")
                    

                         const myHeaders = new Headers();
                         myHeaders.append("APIKEY", process.env.REACT_APP_API_KEY);
                         myHeaders.append("Access-Control-Allow-Origin", "*");
                         
                         
                             const requestOptions = {
                                 method: 'DELETE',      
                                 headers: myHeaders,
                                   redirect:'follow'
                             };
                         
                             const DELETEUser= async () => {
                               
                                  await getUser()
                                  }
                              
                           
                              
                              const getUser = async () =>{
                                 
                                  const url=`https://cfmlogin.summitsafety.com.au/api/user/${accounts[0].username + "/"}`
                                  const res = await fetch(url, requestOptions)
                                  const data = await res.json()
                                  console.log(data)
                                  respRedirect(data)
                                  }
                              
                              DELETEUser()

                       
                            const handleLogout = (logoutType) => {
                        
                                
                                    instance.logoutRedirect({
                                        postLogoutRedirectUri: "/",
                                    });
                                }
                           handleLogout("redirect")             
                    }},3000)
                }
  

    

    },[]);

    return (

        
        <>

           <div className="contentwrapper">
            <h5 className="card-title">Welcome: {accounts[0].name}</h5>
            <br />
            <br />
            <br />
            <p>Redirecting to Webstore</p>
        
            </div>
        </>
    );

};


const MainContent = () => {



    return (
<>
            <AuthenticatedTemplate>
                <div className="profileContent">
                <ProfileContent />
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
  
            </UnauthenticatedTemplate>
        </>
    );
};

export default function App() {

    return (
        <PageLayout>
            <MainContent />

        </PageLayout>
    );
}
